module.exports = __webpack_public_path__ + "img/zxyfw-5.21f6cd0f.jpg";